import Navbar from "./Components/Navbar/Navbar";
import WishlistProvider from "./Context/WishlistContext";
import WishlistPanel from "./Components/Wishlist/WishlistPanel";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import ScrollToTop from "./Components/ScrollTop/ScrollTop";
import Shop from "./Pages/Shop";
import Cart from "./Pages/Cart";
import Product from "./Pages/Product";
import ShopCategory from "./Pages/ShopCategory";
import Footer from "./Components/Footer/Footer";
import LoginSignup from "./Pages/LoginSignup";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { useState } from "react";
import HeaderTitle from "./Components/HederTitle/HeaderTitle";
import Bulk from "./Components/Bulk/Bulk";
import ExplorerIdeas from "./Pages/ExplorerIdeas";
import SearchResults from "./Components/Search/SearchResults";
import AddReview from "./Components/CustomerReviews/AddReview";
import UserDetails from "./Pages/UserDetails";
import TermsAndConditions from "./Components/Info/TermsAndConditions";
import ShippingPolicy from "./Components/Info/ShippingPolicy";
import RefundPolicy from "./Components/Info/RefundPolicy";
import PrivacyPolicy from "./Components/Info/PrivacyPolicy";
import AboutUs from "./Components/About/About-us";
import ReviewsPage from "./Components/Customer/ReviewPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// dev (npm start) uses the local backend; production build uses the live API
export const backend_url =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000"
    : "https://api.aavryaafabhub.com";
export const currency = "₹";

export const MainaLayout = () => {
  const location = useLocation();
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    setSearchResults([]);
  }, [location.pathname]);

  return (
    <div>
      <Navbar setSearchResults={setSearchResults} />
      <div className="min-h-[calc(100vh-428px)] mt-[20px]">
        {searchResults.length > 0 ? (
          <SearchResults
            results={searchResults}
            setSearchResults={setSearchResults}
          />
        ) : (
          <Outlet />
        )}
      </div>
      <Bulk />
      <Footer />
    </div>
  );
};

function App() {
  const [showContactOptions, setShowContactOptions] = useState(false);
  return (
    <WishlistProvider>
    <div>
      <Router>
        <ToastContainer position="top-center" autoClose={2500} />
        <WishlistPanel />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainaLayout />}>
            <Route path="/" element={<Shop gender="all" />} />
            <Route path="/product" element={<Product />}>
              <Route path=":productId/:productName" element={<Product />} />
            </Route>
            <Route path="/add-review/:id" element={<AddReview />} />
            <Route
              path="/collections/:subcategory"
              element={<ShopCategory category="new-arrivals" />}
            />
            <Route path="/cart" element={<Cart />} />
            <Route path="/login" element={<LoginSignup />} />
            <Route path="/summa" element={<HeaderTitle />} />
            <Route path="/explore-our-ideas" element={<ExplorerIdeas />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/user-profile" element={<UserDetails />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/terms-conditions" element={<TermsAndConditions />} />
            <Route path="/checkout" element={<Cart />} />
            <Route path="/reviews" element={<ReviewsPage />} />
          </Route>
        </Routes>

        {/* Floating Contact Buttons */}
        <div className="floating-contact">
          {showContactOptions && (
            <>
              <a
                href="https://wa.me/919944592904"
                className="contact-option whatsapp"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp size={25} />
              </a>
              <a href="tel:9944592904" className="contact-option call">
                <FaPhoneAlt size={25} />
              </a>
            </>
          )}
          <button
            className="contact-toggle"
            onClick={() => setShowContactOptions(!showContactOptions)}
          >
            <FaWhatsapp size={25} />
          </button>
        </div>
      </Router>
    </div>
    </WishlistProvider>
  );
}

export default App;
